<template>
  <a-modal
    title="Add New Tag"
    :visible="visible"
    :confirmLoading="isSubmitting"
    @ok="handleOk"
    @cancel="handleCancel"
    okText="Create"
    cancelText="Cancel"
  >
    <a-form :form="tagForm" @submit="handleSubmit">
      <a-form-item label="Tag Name">
        <a-input
          v-decorator="[
            'name',
            {
              rules: [
                {
                  required: true,
                  message: 'Please input Tag Name!'
                }
              ]
            }
          ]"
          placeholder="Enter tag name"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
  import TagsService from '../services/tags.service';

  export default {
    name: 'TagAdd',
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isSubmitting: false
      };
    },
    mounted() {
      this.$nextTick(() => {
        this.tagForm = this.$form.createForm(this);
      });
    },
    methods: {
      handleSubmit(event, values = null) {
        event.preventDefault();
        if (values) {
          // Values passed directly from handleOk
          this.submitForm(values);
        } else {
          // Normal form submission
          this.tagForm.validateFields((err, formValues) => {
            if (!err) {
              this.submitForm(formValues);
            }
          });
        }
      },
      submitForm(values) {
        this.isSubmitting = true;
        TagsService.create({ tagName: values.name }).then(() => {
          this.$showSuccessMessage('Tag created successfully');
          this.tagForm.resetFields();
          this.$emit('created');
          this.$emit('close');
        }).catch(() => {
          this.$showErrorMessage('Failed to create tag');
        }).finally(() => {
          this.isSubmitting = false;
        });
      },
      handleOk() {
        this.tagForm.validateFields((err, values) => {
          if (!err) {
            this.handleSubmit({ preventDefault: () => {} }, values);
          }
        });
      },
      handleCancel() {
        this.tagForm.resetFields();
        this.$emit('close');
      }
    }
  };
</script>

<style lang="scss" scoped></style>
